import { BusinessSeatsType, MoneyType } from '@api';
import {
  formatCurrency,
  formatNumber,
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueBusinessSeatsTableRowType } from '../../data';

type VenueBusinessSeatsTableRowPropsType = {
  venueBusinessSeats: BusinessSeatsType;
  row: VenueBusinessSeatsTableRowType;
};

export const VenueBusinessSeatsTableRow: React.FC<
  VenueBusinessSeatsTableRowPropsType
> = ({ venueBusinessSeats, row }) => {
  const { t } = useTranslation('venueDetailsOverview');

  const label = t(`VENUE_BUSINESS_SEATS.ROWS.${row.label}`);
  const value = getValueByPath(venueBusinessSeats, row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'maxSeats':
        return formatNumber(Number(value));
      case 'uplift':
      case 'share':
        return formatCurrency(value as MoneyType);
      case 'notes':
        return String(value);
    }
  };
  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
